<template>
  <sliding-modal :is-open="isOpen" @secondary="$emit('secondary')">
    <div class="CONFIRMATION-BODY">
      <vk-modal-header v-if="$slots.header" class="HEADER">
        <slot name="header" />
      </vk-modal-header>
      <vk-modal-content class="CONTENT" selenium="pass-modal-content">
        <slot />
      </vk-modal-content>
      <vk-modal-footer class="FOOTER">
        <slot name="secondary">
          <button
              class="BUTTON-TERTIARY"
              selenium="pass-modal-cancel-button"
              @click.prevent="$emit('secondary')">
            Cancel
          </button>
        </slot>
        <slot name="primary">
          <button
              class="BUTTON-PRIMARY"
              selenium="pass-modal-confirm-button"
              @click.prevent="$emit('primary')">
            Confirm
          </button>
        </slot>
      </vk-modal-footer>
    </div>
  </sliding-modal>
</template>

<script>
import SlidingModal from './SlidingModal';

export default {
  name: 'confirmation-modal',
  components: {
    SlidingModal,
  },
  props: {
    isOpen: Boolean,
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  @import "~@/views/Dashboard/constants";

  .CONFIRMATION-BODY {
    @include responsive(min-width, 100%, $confirmation-modal-width);
    @include responsive(width, 100%, $confirmation-modal-width);
    @include responsive(max-width, 100%, $confirmation-modal-width);
    display: flex;
    flex-direction: column;
  }

  .HEADER {
    @include h6;
    padding: $unit;
    font-weight: 700;
    text-align: center;
    border-bottom: 1px solid $color-gray30;
  }

  .CONTENT {
    padding: 4*$unit 3*$unit 3*$unit;
    text-align: center;
  }

  .FOOTER {
    display: flex;
    padding: 0 3*$unit 3*$unit;
    background-color: white;
  }

  .BUTTON-TERTIARY,
  .BUTTON-PRIMARY {
    @include button-medium;
    display: flex;
    flex: 1 1 auto;
    font-weight: 600;
  }

  .BUTTON-TERTIARY {
    @include button-tertiary;
    margin-right: 1.5*$unit;
  }

  .BUTTON-PRIMARY {
    @include button-primary;
    margin-left: 1.5*$unit;
  }
</style>
